import { render, staticRenderFns } from "./verify-otp.vue?vue&type=template&id=7fc553d7&scoped=true"
import script from "./verify-otp.vue?vue&type=script&lang=ts"
export * from "./verify-otp.vue?vue&type=script&lang=ts"
import style0 from "./verify-otp.vue?vue&type=style&index=0&id=7fc553d7&lang=scss"
import style1 from "./verify-otp.vue?vue&type=style&index=1&id=7fc553d7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc553d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc553d7')) {
      api.createRecord('7fc553d7', component.options)
    } else {
      api.reload('7fc553d7', component.options)
    }
    module.hot.accept("./verify-otp.vue?vue&type=template&id=7fc553d7&scoped=true", function () {
      api.rerender('7fc553d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/verify-otp.vue"
export default component.exports